import React from "react";
import "./DuplicateItemModal.scss";
import OwButton from "../../shared/OwButton/OwButton";
import OwTitle from "../../shared/OwTitle/OwTitle";

export type DuplicateItemAction = "update_qty" | "add_new_line" | "cancel";

type Props = {
    itemName: string;
    existingQty: number;
    newQty: number;
    closeModalFn: (action: DuplicateItemAction) => void;
};

export const DuplicateItemModal: React.FC<Props> = (props) => {
    const closeModal = () => {
        props.closeModalFn("cancel");
    };

    const updateQty = () => {
        props.closeModalFn("update_qty");
    };

    const addNewLine = () => {
        props.closeModalFn("add_new_line");
    };

    return (
        <div className={"DuplicateItemModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-copy"} title={"item_already_in_cart"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div className={"mt-3"}>
                <p className={"mb-1"}>
                    <strong>{props.itemName}</strong>
                </p>
                <p className={"text-muted mb-0"}>
                    Current qty: {props.existingQty} &middot; Adding: {props.newQty}
                </p>
            </div>

            <div className={"mt-4 d-flex gap-2"}>
                <OwButton title={"update_quantity"} leftIconClass={"fas fa-plus-circle"} fn={updateQty} />
                <OwButton title={"add_as_new_line"} className={"btn-secondary"} leftIconClass={"fas fa-layer-plus"} fn={addNewLine} />
            </div>
        </div>
    );
};
